'use strict';exports.__esModule = true;exports.deleteEmployee = exports.editEmployee = exports.closeAddNewStaffEmployeesForm = exports.setCurrentPaginationStepEmployees = exports.openAddNewStaffEmployeesForm = exports.addEmployee = exports.getMyStaffEmployees = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');
var _formatApiError = require('../../helpers/formatApiError');var _formatApiError2 = _interopRequireDefault(_formatApiError);
var _userAuthentication = require('./userAuthentication');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

promise = _reduxLoop.Effects.promise,constant = _reduxLoop.Effects.constant;

var openAddNewStaffEmployeesForm = (0, _reduxAct.createAction)('/OPEN_ADD_NEW_STAFF_EMPLOYEES_FORM');
var closeAddNewStaffEmployeesForm = (0, _reduxAct.createAction)('/CLOSE_ADD_NEW_STAFF_EMPLOYEES_FORM');

var getMyStaffEmployees = (0, _reduxAct.createAction)('/GET_MY_STAFF_EMPLOYEES');
var getMyStaffEmployeesSuccess = (0, _reduxAct.createAction)('/GET_MY_STAFF_EMPLOYEES_SUCCESS');
var getMyStaffEmployeesFail = (0, _reduxAct.createAction)('/GET_MY_STAFF_EMPLOYEES_FAIL');

var addEmployee = (0, _reduxAct.createAction)('/ADD_EMPLOYEE');
var addEmployeeSuccess = (0, _reduxAct.createAction)('/ADD_EMPLOYEE_SUCCESS');
var addEmployeeFail = (0, _reduxAct.createAction)('/ADD_EMPLOYEE_FAIL');

var editEmployee = (0, _reduxAct.createAction)('/EDIT_EMPLOYEE');
var editEmployeeSuccess = (0, _reduxAct.createAction)('/EDIT_EMPLOYEE_SUCCESS');
var editEmployeeFail = (0, _reduxAct.createAction)('/EDIT_EMPLOYEE_FAIL');

var deleteEmployee = (0, _reduxAct.createAction)('/DELETE_EMPLOYEE');
var deleteEmployeeSuccess = (0, _reduxAct.createAction)('/DELETE_EMPLOYEE_SUCCESS');
var deleteEmployeeFail = (0, _reduxAct.createAction)('/DELETE_EMPLOYEE_FAIL');

var setCurrentPaginationStepEmployees = (0, _reduxAct.createAction)('/SET_CURRENT_PAGINATION_STEP_EMPLOYEES');

var initialState = {
  addNewStaffEmployeesFormOpen: false,
  loading: false,
  loaded: false,

  addEmployeeLoading: false,
  addEmployeeLoaded: false,

  editEmployeeLoading: false,
  editEmployeeLoaded: false,

  query: null,
  skip: null,
  data: [],
  meta: null,
  filter: {},
  error: null,
  totalEmployees: 0,
  currentPaginationStepEmployees: 1 };


var fetchLoad = function fetchLoad(_ref) {var _ref$params = _ref.params,params = _ref$params === undefined ? {} : _ref$params,token = _ref.token;return (
    _axios2.default.get('/users/employees', {
      params: params,
      headers: { access_token: token } }).

    then(getMyStaffEmployeesSuccess, getMyStaffEmployeesFail));};

var fetchAddEmployee = function fetchAddEmployee(_ref2) {var data = _ref2.data,token = _ref2.token;return (
    _axios2.default.post('/users/employees', data, {
      headers: { access_token: token } }).

    then(addEmployeeSuccess, addEmployeeFail));};

var fetchEditEmployee = function fetchEditEmployee(_ref3) {var data = _ref3.data,token = _ref3.token,id = _ref3.id;return (
    _axios2.default.put('/users/employees/' + id, data, {
      headers: { access_token: token } }).

    then(editEmployeeSuccess, editEmployeeFail));};

var fetchDeleteEmployee = function fetchDeleteEmployee(_ref4) {var token = _ref4.token,id = _ref4.id;return (
    _axios2.default.delete('/users/employees/' + id, {
      headers: { access_token: token } }).

    then(deleteEmployeeSuccess, deleteEmployeeFail));};

var handleLoad = function handleLoad(state, action) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true,
    loaded: false,
    filter: action.params ? action.params : {} }),
  promise(fetchLoad, action));};

var handleAddEmployee = function handleAddEmployee(state, action) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    addEmployeeLoading: true,
    addEmployeeLoaded: false }),
  promise(fetchAddEmployee, action));};

var handleEditEmployee = function handleEditEmployee(state, action) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    editEmployeeLoading: true,
    editEmployeeLoaded: false }),
  promise(fetchEditEmployee, action));};

var handleDeleteEmployee = function handleDeleteEmployee(state, action) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true,
    loaded: false }),
  promise(fetchDeleteEmployee, action));};

var handleLoadMyStaffEmployeesSuccess = function handleLoadMyStaffEmployeesSuccess(state, action) {
  var data = (0, _get2.default)(action, 'data.data', []);
  var meta = (0, _get2.default)(action, 'data.meta', {});

  return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    totalEmployees: meta.total,
    data: data,
    meta: meta });

};

var handleLoadMyStaffEmployeesFail = function handleLoadMyStaffEmployeesFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Error load my employees');

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    data: [],
    error: error });

};

var handleAddEmployeeSuccess = function handleAddEmployeeSuccess(state, action) {
  var data = (0, _get2.default)(action, 'data.data', []);
  var meta = (0, _get2.default)(action, 'data.meta', {});
  var token = (0, _get2.default)(action, 'config.headers.access_token');

  return (0, _reduxLoop.loop)(Object.assign({},

  state, {
    addEmployeeLoading: false,
    addEmployeeLoaded: true,
    totalEmployees: meta.total,
    data: data,
    meta: meta }),

  constant((0, _userAuthentication.authUserByToken)(token)));

};

var handleAddEmployeeFail = function handleAddEmployeeFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Error add user to my employees');

  return Object.assign({},
  state, {
    addEmployeeLoading: false,
    addEmployeeLoaded: false,
    error: error });

};

var handleDeleteEmployeeSuccess = function handleDeleteEmployeeSuccess(state, action) {
  var data = (0, _get2.default)(action, 'data.data', []);
  var meta = (0, _get2.default)(action, 'data.meta', {});
  var token = (0, _get2.default)(action, 'config.headers.access_token');

  return (0, _reduxLoop.loop)(Object.assign({},

  state, {
    loading: false,
    loaded: true,
    totalEmployees: meta.total,
    data: data,
    meta: meta }),

  constant((0, _userAuthentication.authUserByToken)(token)));

};

var handleDeleteEmployeeFail = function handleDeleteEmployeeFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Error delete user to my employees');

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    error: error });

};

var handleEditEmployeeSuccess = function handleEditEmployeeSuccess(state, action) {
  var data = (0, _get2.default)(action, 'data.data', []);
  var meta = (0, _get2.default)(action, 'data.meta', {});
  var token = (0, _get2.default)(action, 'config.headers.access_token');

  return (0, _reduxLoop.loop)(Object.assign({},

  state, {
    editEmployeeLoading: false,
    editEmployeeLoaded: true,
    totalEmployees: meta.total,
    data: data,
    meta: meta }),

  constant((0, _userAuthentication.authUserByToken)(token)));

};

var handleEditEmployeeFail = function handleEditEmployeeFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Error edit employee');

  return Object.assign({},
  state, {
    editEmployeeLoading: false,
    editEmployeeLoaded: false,
    error: error });

};

var handleOpenAddNewStaffEmployeesForm = function handleOpenAddNewStaffEmployeesForm(state) {return Object.assign({},
  state, {
    addNewStaffEmployeesFormOpen: true });};


var handleCloseAddNewStaffEmployeesForm = function handleCloseAddNewStaffEmployeesForm(state) {return Object.assign({},
  state, {
    addNewStaffEmployeesFormOpen: false });};


var handleSetCurrentPaginationStepEmployees = function handleSetCurrentPaginationStepEmployees(state, action) {return Object.assign({},
  state, {
    currentPaginationStepEmployees: action });};


var myStaffEmployees = (0, _reduxAct.createReducer)(function (on) {
  on(openAddNewStaffEmployeesForm, handleOpenAddNewStaffEmployeesForm);
  on(closeAddNewStaffEmployeesForm, handleCloseAddNewStaffEmployeesForm);

  on(getMyStaffEmployees, handleLoad);
  on(getMyStaffEmployeesSuccess, handleLoadMyStaffEmployeesSuccess);
  on(getMyStaffEmployeesFail, handleLoadMyStaffEmployeesFail);

  on(addEmployee, handleAddEmployee);
  on(addEmployeeSuccess, handleAddEmployeeSuccess);
  on(addEmployeeFail, handleAddEmployeeFail);

  on(editEmployee, handleEditEmployee);
  on(editEmployeeSuccess, handleEditEmployeeSuccess);
  on(editEmployeeFail, handleEditEmployeeFail);

  on(deleteEmployee, handleDeleteEmployee);
  on(deleteEmployeeSuccess, handleDeleteEmployeeSuccess);
  on(deleteEmployeeFail, handleDeleteEmployeeFail);

  on(setCurrentPaginationStepEmployees, handleSetCurrentPaginationStepEmployees);
}, initialState);exports.


getMyStaffEmployees = getMyStaffEmployees;exports.
addEmployee = addEmployee;exports.
openAddNewStaffEmployeesForm = openAddNewStaffEmployeesForm;exports.
setCurrentPaginationStepEmployees = setCurrentPaginationStepEmployees;exports.
closeAddNewStaffEmployeesForm = closeAddNewStaffEmployeesForm;exports.
editEmployee = editEmployee;exports.
deleteEmployee = deleteEmployee;exports.default =


myStaffEmployees;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/myStaffEmployees.js
// module id = 1279
// module chunks = 0